/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
/* eslint-disable no-loop-func */
import onDOMContentLoaded from '../utils/on-dom-content-loaded';

const handleFormBuilderEvents = () => {
  const nextIsError = (input) => input.nextSibling.className === 'input-error-message';

  const formElements = document.querySelectorAll('.form-group');
  if (formElements.length > 0) {
    for (let i = 0; i < formElements.length; i++) {
      formElements[i].addEventListener('input', () => {
        const children = formElements[i].getElementsByTagName('*');
        const input = Array.from(children).find(
          (child) =>
            child.tagName === 'INPUT' || child.tagName === 'TEXTAREA' || child.tagName === 'SELECT'
        );

        $(input).parent().siblings().remove('.input-error-message');
        $(input).parent().parent().siblings().remove('.input-error-message'); // Remove error message for radio buttons

        if (input.value || input.checked) {
          input.classList.add('has-value');
        } else if (!input.value || !input.checked) {
          input.classList.remove('has-value');
        }

        if ((input.type === 'radio' || input.type === 'checkbox') && !input?.checked) {
          input.classList.remove('has-value');
        }

        const errorMessages = window.form.errors;
        const { validity } = input;
        let errorMessage = '';

        /*
         * Check if the input is valid
         * Check if the input is required
         */
        if (validity.typeMismatch) {
          errorMessage = errorMessages.patternMismatch;
        } else if ($(input).prop('required') && !input.value) {
          errorMessage = errorMessages.required;
        } else {
          errorMessage = '';
        }

        const newErrorElement = document.createElement('span');
        newErrorElement.classList.add('input-error-message');
        newErrorElement.innerHTML = errorMessage;
        const errorElement = input.parentElement.querySelector('span.input-error-message');

        if (!nextIsError(input) && errorMessage) {
          input.insertAdjacentElement('afterend', newErrorElement);
        } else if (nextIsError(input) && errorMessage) {
          errorElement.innerHTML = errorMessage;
        } else if (!errorMessage && input.parentElement.querySelector('span.input-error-message')) {
          errorElement.remove();
        }
      });
    }
  }

  // validation for numeric input
  const numberInputs = document.getElementsByClassName('numeric-input');
  if (numberInputs.length > 0) {
    for (let i = 0; i < numberInputs.length; i += 1) {
      numberInputs[i].addEventListener('input', () => {
        const children = numberInputs[i].getElementsByTagName('*');
        const input = Array.from(children).find((child) => child.tagName === 'INPUT');

        const errorMessages = window.form.errors;
        let errorMessage = '';

        if (!/^[0-9]*$/.test(input.value)) {
          errorMessage = errorMessages.badInputNumber;
        } else {
          errorMessage = '';
        }

        const newErrorElement = document.createElement('span');
        newErrorElement.classList.add('input-error-message');
        newErrorElement.innerHTML = errorMessage;
        const errorElement = input.parentElement.querySelector('span.input-error-message');

        if (!nextIsError(input) && errorMessage) {
          input.insertAdjacentElement('afterend', newErrorElement);
        } else if (nextIsError(input) && errorMessage) {
          errorElement.innerHTML = errorMessage;
        } else if (!errorMessage && input.parentElement.querySelector('span.input-error-message')) {
          errorElement.remove();
        }
      });
    }
  }

  // validating requried fields have values, if not display error
  const submitButton = document.querySelector("div.ktc-default-section ~ input[type='submit']");
  submitButton?.addEventListener('click', () => {
    $('span.required-error').remove();
    const requiredFields = document.querySelectorAll(
      "input[required]:not([type='radio'], [type='checkbox'], .has-value), .ktc-radio-list:has(input[required]:not(.has-value)):not(:has(input[type='radio']:checked)), .ktc-checkbox-list:has(input[required]:not(.has-value)):not(:has(input[type='checkbox']:checked)), .custom-checkbox:has(input[required]:not(.has-value)), checkbox[required]:not(.has-value), .select:has(select[required]:not(.has-value)), textarea[required]"
    );
    requiredFields.forEach((field) => {
      if (!nextIsError(field) && !field.value) {
        const newErrorElement = document.createElement('span');
        newErrorElement.classList.add('input-error-message');
        newErrorElement.innerHTML = window.form.errors?.required;
        field.insertAdjacentElement('afterend', newErrorElement);
      }
    });
  });
};

const handleInputLabels = (selector) => {
  document.querySelectorAll(selector).forEach((input) => {
    input.addEventListener('focus', (e) => {
      e.target.closest('.ktc-input-wrapper').classList.add('focus-styles');
      const errorMessage = e.target
        .closest('.ktc-input-wrapper')
        .querySelector('.input-error-message');

      if (errorMessage) {
        e.target.style.setProperty('--input-border-color', 'var(--bdo-red)');
      } else {
        e.target.style.setProperty('--input-border-color', 'var(--grey)');
      }
    });
  });

  document.querySelectorAll(selector).forEach((input) => {
    input.addEventListener('blur', (e) => {
      if (!e.target.value && e.target.type !== 'date') {
        e.target.closest('.ktc-input-wrapper').classList.remove('focus-styles');
      }

      const errorMessage = e.target
        .closest('.ktc-input-wrapper')
        .querySelector('.input-error-message');

      if (errorMessage) {
        e.target.style.setProperty('--input-border-color', 'var(--bdo-red)');
      } else {
        e.target.style.setProperty('--input-border-color', 'var(--grey)');
      }
    });
  });

  document.querySelectorAll(selector).forEach((input) => {
    input.addEventListener('input', (e) => {
      setTimeout(() => {
        const errorMessage = e.target
          .closest('.ktc-input-wrapper')
          .querySelector('.input-error-message');
        // eslint-disable-next-line eqeqeq
        if (errorMessage || (e.target.getAttribute('required') == true && !e.target.value)) {
          e.target.style.setProperty('--input-border-color', 'var(--bdo-red)');
        } else if (e.target === document.activeElement) {
          e.target.style.setProperty('--input-border-color', 'var(--charcoal-2)');
        } else {
          e.target.style.setProperty('--input-border-color', 'var(--grey)');
        }
      }, 500);
    });
  });
};

const handleDatePickerLabel = () => {
  document.querySelectorAll("input[type='date']").forEach((input) => {
    input.closest('.ktc-input-wrapper').classList.add('focus-styles');
  });
};

const handleLabelsOnFormSubmit = (selector) => {
  document.querySelectorAll(selector).forEach((input) => {
    if (input.value || input.checked) {
      input.classList.add('has-value');
    } else if (!input.value || !input.checked) {
      input.classList.remove('has-value');
    }

    if ((input.type === 'radio' || input.type === 'checkbox') && !input?.checked) {
      input.classList.remove('has-value');
    }
  });
};

const formEventListeners = () => {
  handleFormBuilderEvents();
  handleInputLabels('.ktc-input-wrapper input');
  handleInputLabels('.ktc-input-wrapper textarea');
  handleInputLabels('.ktc-input-wrapper select');
  handleDatePickerLabel();
};

const listenForXHRRequests = () => {
  const forms = document.querySelectorAll('form[action*="/kentico"]');

  const oldXHROpen = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function (method, url) {
    this.addEventListener('loadend', () => {
      forms.forEach((form) => {
        const formAction = form.getAttribute('action');

        if (formAction && url.includes(formAction)) {
          handleLabelsOnFormSubmit('.ktc-input-wrapper input');
          handleLabelsOnFormSubmit('.ktc-input-wrapper textarea');
          handleLabelsOnFormSubmit('.ktc-input-wrapper select');
          formEventListeners();
        }
      });
    });
    // eslint-disable-next-line prefer-rest-params
    return oldXHROpen.apply(this, arguments);
  };
};

onDOMContentLoaded().then(() => {
  formEventListeners();
  listenForXHRRequests();
});
